import React from 'react'
import classes from './PieBar.css'

export const PieBar = props => {
  const {
    sections,
  } = props

  const renderSections = () => {
    const content = []
    Object.keys(sections).forEach(key => {
      content.push(<div
        key={key}
        className={classes.section}
        style={{
          width: `${sections[key].percentage}%`,
          backgroundColor: sections[key].color,
        }}
      />)
    })
    return content
  }

  return (
    <div className={classes.pieBar}>
      {renderSections()}
    </div>
  )
}

export default PieBar



// WEBPACK FOOTER //
// ./src/legacy/components/PieBar/PieBar.jsx